/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsultationMemoDto } from '../../models/consultation-memo-dto';
import { ConsultationMemoResponseDto } from '../../models/consultation-memo-response-dto';

export interface ConsultationAdminControllerCreateMemoV1$Params {
  id: string;
      body: ConsultationMemoDto
}

export function consultationAdminControllerCreateMemoV1(http: HttpClient, rootUrl: string, params: ConsultationAdminControllerCreateMemoV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationMemoResponseDto>> {
  const rb = new RequestBuilder(rootUrl, consultationAdminControllerCreateMemoV1.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsultationMemoResponseDto>;
    })
  );
}

consultationAdminControllerCreateMemoV1.PATH = '/api/v1/consultations/admin/{id}/memos';
